import React, { useEffect, useState } from 'react';
import { Platform, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import NavBarButton from './NavBarButton';
import useStyles from '../../../hooks/styles-hook';
import { useAppSelector } from '../../../hooks/store-hook';
import { faBullhorn, faHouseLaptop, faLocationCheck, faStreetView } from '@fortawesome/pro-regular-svg-icons';
import { useQuery } from '@tanstack/react-query';
import { MyMissionClient } from '../../../api/api.g';
import useApi from '../../../hooks/api-hook';
import useTranslation from '../../../hooks/translation-hook';
import { LoggedState } from '../../../models/AuthModelsCommon';
import useCustomTheme from '../../../hooks/theme-hook';
import useReferAFriendEnabled from '../../../hooks/refer-a-friend-settings-hook';
import useRemoteMissionsEnabled from '../../../hooks/remote-missions-settings-hook';

const NavBar = () => {
  const t = useTranslation();
  const themePreference = useAppSelector((state) => state.userPrefs.theme);
  const navBarVisible = useAppSelector((state) => state.navBar.visible);
  const loggedState = useAppSelector((selector) => selector.auth.logged);
  const authToken = useAppSelector((selector) => selector.auth.idToken);
  const missionListSeed = useAppSelector((selector) => selector.missions.missionListSeed);
  const styles = useStyles((section) => section.navBar);
  const theme = useCustomTheme();
  const apiMyMission = useApi(MyMissionClient);
  const insets = useSafeAreaInsets();
  const referAFriendEnabled = useReferAFriendEnabled();
  const remoteMissionsEnabled = useRemoteMissionsEnabled();

  const [hasMissions, setHasMissions] = useState(false);

  const myMissionsQuery = useQuery({
    enabled: !!authToken && loggedState === LoggedState.Logged,
    staleTime: 30_000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    queryKey: ['myMissions', missionListSeed],
    queryFn: ({ signal }) => {
      const promise = apiMyMission.getMissionsList(apiMyMission.tokenSource?.token);

      // Cancel the request if React Query signals to abort
      signal?.addEventListener('abort', () => {
        apiMyMission.tokenSource?.cancel('Query was cancelled by React Query');
        apiMyMission.onCancel();
      });

      return promise;
    },
  });

  useEffect(() => {
    if (myMissionsQuery.isSuccess) {
      const value = myMissionsQuery.data;

      if (value.missions?.length ?? 0 > 0) {
        setHasMissions(true);
      } else {
        setHasMissions(false);
      }
    }
  }, [myMissionsQuery.isSuccess, myMissionsQuery.data]);

  return (
    <View>
      {navBarVisible && (
        <View
          key={`mobile-nav-${themePreference ?? 'unknown'}`}
          style={[
            {
              backgroundColor: theme.background?.navBar,
              display: 'flex',
              flexDirection: 'row',
              paddingTop: 12,
              borderTopWidth: 1,
              borderTopColor: theme.borderColorLight,
              paddingBottom: Platform.OS === 'android' ? Math.max(insets.bottom, 0) + 8 : 6,
              // Requested QA tuning: push iOS nav bar lower on screen.
              marginBottom: Platform.OS === 'ios' ? -10 : Platform.OS === 'android' ? -Math.max(insets.bottom, 0) : 0,
            },
          ]}
        >
          <NavBarButton image={require('../../../../assets/map.png')} icon={faStreetView} title={t('Missions')} screen="map" />
          {remoteMissionsEnabled && <NavBarButton icon={faHouseLaptop} iconScale={1.4} title={t('remoteNav')} screen="remotemissions" />}
          <NavBarButton
            image={require('../../../../assets/mission.png')}
            icon={faLocationCheck}
            title={t('my_missions')}
            screen="mymissions"
            showIndicator={hasMissions}
          />
          {referAFriendEnabled && <NavBarButton icon={faBullhorn} title={t('my_references')} screen="myreferences" />}
        </View>
      )}
    </View>
  );
};

export default NavBar;
function dispatch(arg0: any) {
  throw new Error('Function not implemented.');
}
